import React from 'react'
import { Linking } from 'react-native'
import { useTranslation } from 'react-i18next'

import {
  DefaultButtonWithText,
  Logo,
  StatusMessageContainer,
  StatusText,
} from '../../../App/Components'
import { StyledScrollView } from '../../../App/Components/AppContainer'
import { useParams } from '../../../Router'
import { useAppSelector } from '../../../store/hooks'
import { customerPortalLinks } from '../../../App/Util/customerPortalUrl'

const AppointmentMoveFailed = () => {
  const { establishmentId } = useParams<{ [key: string]: string }>()
  const { t } = useTranslation()

  const settings = useAppSelector((state) => state.settings.values)

  return (
    <StyledScrollView>
      <Logo />
      <StatusMessageContainer success={false}>
        <StatusText>{t('This appointment can no longer be moved.')}</StatusText>
        <StatusText>
          {t('It may have been cancelled in the meantime.')}
        </StatusText>
      </StatusMessageContainer>
      <DefaultButtonWithText
        onPress={() =>
          Linking.openURL(customerPortalLinks.appointments(establishmentId))
        }
        backgroundcolor={settings.backgroundColor}
        fontcolor={settings.highlightColor}
        hoversensitive
      >
        {t('Back to my appointments')}
      </DefaultButtonWithText>
    </StyledScrollView>
  )
}

export default AppointmentMoveFailed
